import React from 'react';
import BBALoader from '../BBALoader';
import CommunityPostCard from './CommunityPostCard';

const CommunityPostFeed = ({
  posts,
  loading,
  error,
  visibleCount,
  totalCount,
  onLoadMore,
  onLike,
  onDelete,
  onOpenAttachment,
  emptyMessage = 'No posts match your filters yet. Be the first to share something!',
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <BBALoader size={40} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-2xl border border-dashed border-red-300 dark:border-red-800 bg-red-50/80 dark:bg-red-900/10 px-6 py-12 text-center">
        <p className="text-red-600 dark:text-red-400">{error}</p>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-gray-300 dark:border-gray-700 bg-white/70 dark:bg-gray-900/50 px-6 py-12 text-center">
        <p className="text-gray-500 dark:text-gray-400">{emptyMessage}</p>
      </div>
    );
  }

  const visiblePosts = posts.slice(0, visibleCount);
  const hasMore = visibleCount < posts.length;

  return (
    <div className="space-y-4">
      <div className="space-y-4">
        {visiblePosts.map((post) => (
          <CommunityPostCard
            key={post.id}
            post={post}
            onLike={onLike}
            onDelete={onDelete}
            onOpenAttachment={onOpenAttachment}
          />
        ))}
      </div>

      {hasMore && (
        <div className="flex flex-col items-center gap-2 pt-2">
          <button
            type="button"
            onClick={onLoadMore}
            className="px-5 py-2.5 text-sm font-medium rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 shadow-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            Load more
          </button>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Showing {visiblePosts.length} of {totalCount} posts
          </p>
        </div>
      )}
    </div>
  );
};

export default CommunityPostFeed;
